// extracted by mini-css-extract-plugin
export default {"container":"secondHeading_container__Quv9z","headingContainer":"secondHeading_headingContainer__DdoBM","headingText":"secondHeading_headingText__qBruK"};